<template>
  <div>
    <canvas ref="chart" />
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted() {


    setTimeout(() => {

        console.log("3 second time out");

    const ctx = this.$refs.chart.getContext('2d');
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: this.chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 12,
              fontColor: '#333',
              fontStyle: 'bold'
            }
          }],
          yAxes: [{
            ticks: {
              fontSize: 12,
              fontColor: '#333',
              fontStyle: 'bold',
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: false
        }
      }
    });
        

    }, 3000);




},
  watch: {
    chartData() {
      console.log("Watch chartdata");
      this.updateChart();
    }
  },
  methods: {
    renderChart() {
      if (!this.$refs.chart) {
        return;
      }

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      });
    },
    updateChart() {
      if (this.chart) {
        this.chart.data = this.chartData;
        this.chart.update();
      } else {
        this.renderChart();
      }
    }
  },
  destroyed() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
canvas {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// BarChart.vue?be2a3f3c